import { action, makeObservable, observable } from "mobx";

import { toasterInitialData } from "../constants/Toaster";
import { Toaster, ToasterAlignmentHorizontal, ToasterAlignmentVertical, ToasterPosition } from "../types/Toaster.types";

class CommonUnityStore {
  public toasterData: Toaster = toasterInitialData;
  public isDiscardModal: boolean = false;
  public isSEOFeatureEnabled: boolean = false;
  public isMAFeatureEnabled: boolean = false;
  public toasterAlignmentHorizontal: ToasterAlignmentHorizontal = ToasterAlignmentHorizontal.END;
  public toasterAlignmentVertical: ToasterAlignmentVertical = ToasterAlignmentVertical.TOP;
  public toasterPosition: ToasterPosition = ToasterPosition.FIXED;
  public isConnectionsFeatureEnabled: boolean = false;

  constructor() {
    makeObservable(this, {
      //observable
      toasterData: observable,
      isDiscardModal: observable,
      isSEOFeatureEnabled: observable,
      isMAFeatureEnabled: observable,
      toasterAlignmentHorizontal: observable,
      toasterAlignmentVertical: observable,
      toasterPosition: observable,

      //action`
      handleOpenToaster: action,
      handleOnCloseToaster: action,
      handleChangeDiscardModal: action,
      setIsSEOFeatureEnabled: action,
      setIsMAFeatureEnabled: action,
      setToasterAlignmentHorizontal: action,
      setToasterAlignmentVertical: action,
      setToasterPosition: action,
      setIsConnectionsFeatureEnabled: action,
    });
  }

  handleOpenToaster = (toasterItem: Toaster, toasterCloseTiming?: number) => {
    const defaultToasterTiming: number =  toasterCloseTiming || 3000;
    this.toasterData = {
      ...toasterItem,
      array: this.toasterData.array.concat({
        id: `${this.toasterData.id}`,
        timeout: defaultToasterTiming,
      }),
    };
  };

  public setToasterAlignmentHorizontal = (value: ToasterAlignmentHorizontal): void => {
    this.toasterAlignmentHorizontal = value ?? ToasterAlignmentHorizontal.END;
  };

  public setToasterAlignmentVertical = (value: ToasterAlignmentVertical): void => {
    this.toasterAlignmentVertical = value ?? ToasterAlignmentVertical.TOP;
  };

  public setToasterPosition = (value: ToasterPosition): void => {
    this.toasterPosition = value ?? ToasterPosition.FIXED;
  };

  handleOnCloseToaster = () => {
    this.toasterData = {...this.toasterData, array: []};
  };

  handleChangeDiscardModal = (value : boolean) => {
    this.isDiscardModal = value;
  };

  setIsSEOFeatureEnabled = (value: boolean): void => {
    this.isSEOFeatureEnabled = value;
  };

  setIsMAFeatureEnabled = (value: boolean): void => {
    this.isMAFeatureEnabled = value;
  };

  setIsConnectionsFeatureEnabled = (value: boolean): void => {
    this.isConnectionsFeatureEnabled = value;
  };
}
export const commonUnityStore = new CommonUnityStore();
